import styled from 'styled-components';
import { focusVisibleWithOutline } from '../utils/focus-indicator';
import Icon from '../Icon/styles';
const HitAreaElement = styled.span`
  display: ${props => props['data-display'] || 'inline-block'};
  cursor: pointer;
  position: relative;
  line-height: 0;

  ${focusVisibleWithOutline({
  offset: 'default',
  radius: 'default'
})}

  &::after {
    // ::after is used to increase the "hit area" around the element, so mouse clicks don't need to be so precise
    // using ::after and position:absolute to not affect the layout, and still allow margins on the HitAreaElement
    content: '';
    position: absolute;
    background: transparent;
    top: -0.5rem;
    bottom: -0.5rem;
    left: -0.5rem;
    right: -0.5rem;
  }

  &[data-color-hover]:hover,
  &[data-color-hover]:focus-visible {
    color: ${({
  theme,
  'data-color-hover': color
}) => theme.palette[color] || color};

    ${Icon} {
      path {
        transition: color 0.2s ease-out;
        fill: ${({
  theme,
  'data-color-hover': color
}) => theme.palette[color] || color} !important;
      }
    }
  }
`;
export default HitAreaElement;
//# sourceMappingURL=styles.js.map